import React, { useEffect, useState, useContext } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CModal,
  CModalBody,
  CModalFooter,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CFormLabel,
  CFormText,
} from '@coreui/react'
import '../cms/content.scss'
import 'simplebar/dist/simplebar.min.css'
import { isEmpty } from '../../utils/helper'
import { getThumbnail } from '../../utils/helper'
import useAxios from 'axios-hooks'
import { CONTENT_LIST_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loading from 'react-fullscreen-loading'
import { GlobalContext } from 'src/views/context/GlobalState'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import { PAGE_SIZE } from 'src/views/utils/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

const ContentModal = () => {
  const { setLoader, loader, contentModalProps, setContentModalProps } = useContext(AppContext)
  const { selectCallback, type, mappedContentId, mappedContentArray } = contentModalProps
  const [contentData, setContentData] = useState([])
  const [selectedContentId, setSelectedContentId] = useState(
    type === 'single' ? `${mappedContentId}` : [...mappedContentId],
  )
  const [selectedContentArray, setSelectedcontentArray] = useState([...mappedContentArray])
  const [searchText, setSearchText] = useState('')
  const [page, setPage] = useState(1)
  const { userSessionObj } = useContext(GlobalContext)

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: `${CONTENT_LIST_API}?page_size=${PAGE_SIZE}`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    contentListCall({
      params: {
        page: page,
        search_text: searchText,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(contentListLoading)
  }, [contentListLoading])

  useEffect(() => {
    if (contentList && contentList.success) {
      page === 1
        ? setContentData(contentList.data)
        : setContentData((contentData) => [...contentData, ...contentList.data])
    }
  }, [contentList])

  const handleNextPage = () => {
    contentListCall({
      params: {
        page: page + 1,
        search_text: searchText,
      },
    })
    setPage((page) => page + 1)
  }

  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase()
    setSearchText(value)
    if (event.key === 'Enter') {
      setPage(1)
      contentListCall({
        params: {
          page_no: 1,
          search_text: `${value}`,
        },
      })
    }
  }

  const handleClearSearch = () => {
    setSearchText('')
    setPage(1)
    contentListCall({
      params: {
        page_no: 1,
        search_text: ``,
      },
    })
  }

  const handleContentSelect = (info) => {
    if (type === 'single') {
      info._id === selectedContentId ? setSelectedContentId('') : setSelectedContentId(info._id)
      let temp = []
      temp.push(info)
      setSelectedcontentArray(temp)
      return
    }
    let tempArr = selectedContentArray
    let temp = selectedContentId
    let contentIndex = selectedContentId.findIndex((e) => e === info._id)
    if (contentIndex > -1) {
      temp = selectedContentId.filter((e) => e !== info._id)
      tempArr = selectedContentArray.filter((e) => e._id !== info._id)
    } else {
      temp.push(info._id)
      tempArr.push(info)
    }

    setSelectedcontentArray([...tempArr])
    setSelectedContentId([...temp])
  }

  const handleActiveClasses = (info) => {
    let flag = false
    if (type === 'single') {
      flag = info._id === selectedContentId
    } else {
      flag = selectedContentId.findIndex((e) => e === info._id) > -1
    }

    return flag
  }

  const handleSelect = () => {
    if (!isEmpty(selectedContentId)) {
      selectCallback(selectedContentId, selectedContentArray)
      setContentModalProps({})
    }
  }

  return (
    <>
      <CModal scrollable size="xl" visible={true} alignment="center" className="content-modal-full">
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CRow className="mx-5 mt-4">
          <p className="h4 ">Content List</p>
        </CRow>
        <CRow className="mt-2 mx-5">
          <CCol>
            <CFormLabel>Following are the contents which are already in your store.</CFormLabel>
          </CCol>
          <CCol className="d-flex justify-content-end align-items-center position-relative">
            <CFormInput
              type="text"
              style={{ width: '18rem' }}
              placeholder="Search..."
              size="sm"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyPress={(e) => handleSearch(e)}
            />
            {searchText && (
              <FontAwesomeIcon
                className="position-absolute"
                style={{ cursor: 'pointer', marginRight: '0.4rem' }}
                icon={faTimes}
                title="clear"
                onClick={handleClearSearch}
              />
            )}
          </CCol>
        </CRow>
        <CModalBody>
          <CRow className="mx-5">
            <div style={{ maxHeight: '30rem' }} className="table-responsive" id="scrollableDiv">
              <InfiniteScroll
                dataLength={contentData.length} //This is important field to render the next data
                next={handleNextPage}
                hasMore={contentList && contentList.total > page * 20}
                style={{ overflowX: 'hidden' }}
                loader={<p>Loading...</p>}
                className="scrollbar-class"
                height={`30rem`}
                scrollableTarget="scrollableDiv"
              >
                <CTable style={{ textAlign: 'center' }} striped hover>
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell>Thumbnail</CTableHeaderCell>
                      <CTableHeaderCell>Title</CTableHeaderCell>
                      <CTableHeaderCell>Size</CTableHeaderCell>
                      <CTableHeaderCell>Status</CTableHeaderCell>
                      <CTableHeaderCell>Asset Type</CTableHeaderCell>
                      <CTableHeaderCell>Category</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {!isEmpty(contentData) ? (
                      contentData.map((info, index) => {
                        let size = info?.source_asset
                          ? formatBytes(info?.source_asset?.file_metadata?.file_size)
                          : 0

                        let activeFlag = handleActiveClasses(info)
                        return (
                          <CTableRow
                            key={index}
                            className={activeFlag ? 'selcted-content' : ''}
                            onClick={() => handleContentSelect(info)}
                          >
                            <CTableDataCell>
                              <img
                                className="card-img-top"
                                src={getThumbnail(
                                  userSessionObj.session_data.cf_domain_name,
                                  info?.thumbnail?.website?.s3_key,
                                )}
                                alt={info.title}
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null // prevents looping
                                  currentTarget.src = ImageNotFound
                                }}
                                style={{ width: '9.77rem', height: '5.5rem' }}
                              />
                            </CTableDataCell>
                            <CTableDataCell align="middle">{info?.title}</CTableDataCell>
                            <CTableDataCell align="middle">{size}</CTableDataCell>
                            <CTableDataCell align="middle">
                              {info?.publish_policy || '--'}
                            </CTableDataCell>
                            <CTableDataCell align="middle">
                              {info?.video_type || '--'}
                            </CTableDataCell>
                            <CTableDataCell align="middle">
                              {info?.category?.name || '--'}
                            </CTableDataCell>
                          </CTableRow>
                        )
                      })
                    ) : (
                      <CTableDataCell colSpan="7" style={{ textAlign: 'center' }}>
                        <h6 className="mt-3">No Content Added</h6>
                      </CTableDataCell>
                    )}
                  </CTableBody>
                </CTable>
              </InfiniteScroll>
            </div>
            <CFormText className="text-start text-black">{`Showing ${contentData.length} of ${
              contentList?.total || 0
            }`}</CFormText>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton
            style={{ color: 'black', border: '1px solid #bdbdbd', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={() => setContentModalProps({})}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none"
            onClick={handleSelect}
          >
            Select
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ContentModal
